// extracted by mini-css-extract-plugin
export default {"root-layout":"Root_root-layout__KPkP6","main-content":"Root_main-content__3q-sH"};